import { ProductActionType } from '../enums/product-actions/product-action-type.enum';

export class DashboardState {
  constructor(
    public isLoadingByBarcode = false,
    public isLoadingByProductId = false,
    public isSubmitting = false,
    public productActionType = ProductActionType.Consume
  ) {}

  get isLoading(): boolean {
    return this.isLoadingByBarcode || this.isLoadingByProductId;
  }

  set isLoading(value: boolean) {
    this.isLoadingByBarcode = value;
    this.isLoadingByProductId = value;
  }
}
